import { ContratacionesComponent } from './pages/contrataciones/contrataciones.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SolicitudOfertasComponent } from './pages/solicitud-ofertas/solicitud-ofertas.component';
import { ListadoProvinciaComponent } from './pages/solicitud-ofertas/listado-provincia/listado-provincia.component';
import { OfertaProductosComponent } from './pages/oferta-productos/oferta-productos.component';
import { MainPageAcordarComponent } from './pages/main-page-acordar/main-page-acordar.component';
import { OfertaProvinciaComponent } from './pages/oferta-productos/oferta-provincia/oferta-provincia.component';

const routes: Routes = [
	{
		path: '',
		component: MainPageAcordarComponent,
		children: [
			{ path: 'acuerdos-nacionales', component: SolicitudOfertasComponent },
			{ path: 'acuerdos-nacionales/provincias', component: ListadoProvinciaComponent },
			{ path: 'acuerdos-nacionales/provincia/:id_provincia', component: ListadoProvinciaComponent },
			{ path: 'oferta-productos', component: OfertaProductosComponent },
			{ path: 'oferta-productos/provincias', component: OfertaProvinciaComponent },
			{ path: 'oferta-productos/provincia/:id_provincia', component: OfertaProvinciaComponent },
			{ path: 'contrataciones', component: ContratacionesComponent },
			{ path: 'contrataciones/:numero_contratacion', component: ContratacionesComponent },
			{ path: '**', redirectTo: 'acuerdos-nacionales' }
		]
	}
];

@NgModule({
	imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {}
